<div class="version" (click)="refreshApp()">Version: {{ version }}</div>